import { useContext } from "react";
import UserDataPreferenceForm from "../UserDataPreferenceForm";
import { UserDataPreferenceContext } from "..";
import Styles from '../Styles.module.css'

export default function TargetedAdsOptOutView(){
  const { setTitle } = useContext(UserDataPreferenceContext);
  setTitle("Residents Outside of NJ, PA, MI - Opt-Out of Targeted Advertising")

  return (
    <>
      <p>
        To opt-out of targeted advertising for residents outside of New Jersey, Pennsylvania, or Michigan, 
        please enter your information below and click submit.
      </p>
      <p>
        For more information about our Privacy Notice, <a href="/privacy-policy" className={Styles.link}>click here</a>.
      </p>
      <UserDataPreferenceForm 
        successMessage={"You have been opted-out. Thank you."}
        enableEmail={true} dataType="Advertising"
        status="Opt Out"
      />
      <p>Previously opted-out and would like to opt-in? <a href="/optout?v=targeted-ads-opt-in" className={Styles.link}>Click here to opt-in targeted advertising.</a></p>
    </>
  )
}